/** Navigation only. Checkout continues to verify the authoritative billing status. */
export function showPremiumOffer(user: { rol?: string; subscription_end_date?: string; pro_status_active_until?: string } | null, loading = false, now = Date.now()): boolean {
  if (loading) return false;
  const role = user?.rol?.trim().toLowerCase().split('.').pop();
  if (role === 'admin' || role === 'administrator') return false;
  if (role !== 'pro' && role !== 'premium') return true;
  const expiry = user?.subscription_end_date || user?.pro_status_active_until;
  if (!expiry) return false;
  // Backend naive datetimes are UTC, not the browser's local time.
  const timestamp = Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(expiry) ? expiry : `${expiry}Z`);
  return Number.isFinite(timestamp) && timestamp <= now;
}

export function hasProAccess(
  user: { rol?: string; subscription_end_date?: string; pro_status_active_until?: string } | null | undefined,
  now = Date.now(),
): boolean {
  if (!user) return false;
  const role = user.rol?.trim().toLowerCase().split('.').pop();
  if (role === 'admin' || role === 'administrator') return true;
  if (role !== 'pro' && role !== 'premium') return false;
  return !showPremiumOffer(user, false, now);
}
